angular.module('NumbersEditor')
    .controller('SettingsController', [
        '$scope', 'SettingFactory', '$rootScope', '$route', 'appInfoFactory',
        function ($scope, settingFactory, $rootScope, $route, appInfoFactory) {

            function getSettings() {
                settingFactory.GetAll()
                    .success(function (settings) {
                        $scope.Settings = settings;
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            }

            function init() {
                $rootScope.SetAppTitle("Settings", "Settings");
                getSettings();
                $scope.NewSetting = {
                    Key: "",
                    Value: "",
                    Type: "DATETIME"
                }
            };

            init();
            $scope.form = {};

            $scope.NewSettingSave = function () {
                settingFactory.Save($scope.NewSetting)
                    .success(function () {
                        $route.reload();
                        $.message(MessageText.SettingSuccessfullySaved, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            $scope.UpdateSetting = function (setting) {
                settingFactory.Update(setting)
                    .success(function () {
                        $route.reload();
                        $.message(MessageText.SettingSuccessfullyUpdated, MessageType.Success);
                    })
                    .error(function (error) {
                        $.message(error.ExceptionMessage, MessageType.Error);
                    });
            };

            $scope.Validate = function (key) {
                $scope.form.SettingsForm.$invalid = false;
                var x = Enumerable.From($scope.Settings)
                    .Where(function (x) {
                        return x.Key === key;
                    })
                    .ToArray();
                if (x[0].Value !== undefined) {
                    var scheduledDate = new Date(x[0].Value);

                    appInfoFactory.getDateTime()
                        .success(function (dateTime) {
                            var today = new Date(JSON.parse(dateTime));
                            today.setHours(0);
                            today.setMinutes(0);
                            today.setSeconds(0);
                            today.setMilliseconds(0);
                            if (scheduledDate < today) {
                                $scope.form.SettingsForm.$invalid = true;
                            }
                        }).error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                }
            };
        }
    ]);